import { Icon, Txt } from '@vst/beam';
import { Alert } from '@vst/beam-icons/illustrative-icons';
import { useTranslation } from 'react-i18next';

import { CustomStandardModal } from '@app/components/Modal';

import styles from './ecaErrorModal.module.scss';

type EcaErrorModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onRetry: () => void;
};

export const EcaErrorModal = ({ isOpen, onClose, onRetry }: EcaErrorModalProps) => {
  const { t } = useTranslation('SignContract');

  return (
    <CustomStandardModal
      isOpen={isOpen}
      onClose={onClose}
      size="medium"
      header={null}
      actions={{
        primary: {
          label: t('errorModal.primaryButton'),
          onClick: onRetry,
          minWidth: '200px',
        },
      }}
      surfaceProps={{ className: styles['modal-content'] }}
    >
      <div className={styles['modal-body']}>
        <div data-cy="Alert-Icon">
          <Icon icon={Alert} size={96} color={'alert_400'} mb={'32px'} data-cy={'error-modal-eca-icon'} />
        </div>
        <Txt variant="heading4" className={styles['header']} mb={'24px'} data-cy={'error-modal-eca-header'}>
          {t('errorModal.header')}
        </Txt>
        <Txt variant={'bodyLargeRegular'} className={styles['subheader']} data-cy={'error-modal-eca-description'}>
          {t('errorModal.description')}
        </Txt>
      </div>
    </CustomStandardModal>
  );
};
